import { useCallback, useReducer } from "react";
import { castDraft, produce } from "immer";
/**
 * Handles sort, filter and pagination state.
 * @param initFilter Initial filter value
 * @param initSort Initial sort value
 * @param initPagination Initial pagination value
 */
export function useFilterSortPagination(initFilter, initSort, initPagination = { currentPage: 1, itemsPerPage: 10 }) {
    const reducer = (state, action) => {
        switch (action.type) {
            case "FILTER_UPDATED":
                return produce(state, (draftState) => {
                    draftState.filter = castDraft(action.payload);
                    draftState.pagination.currentPage = 1;
                });
            case "SORT_UPDATED":
                return produce(state, (draftState) => {
                    draftState.sort = castDraft(action.payload);
                    draftState.pagination.currentPage = 1;
                });
            case "PAGINATION_UPDATED":
                return produce(state, (draftState) => {
                    draftState.pagination = action.payload;
                });
            case "RESET":
                return produce(state, (draftState) => {
                    draftState.pagination = initPagination;
                    draftState.sort = castDraft(initSort);
                    draftState.filter = castDraft(initFilter);
                });
            default:
                return state;
        }
    };
    const [state, dispatch] = useReducer(reducer, {
        filter: initFilter,
        sort: initSort,
        pagination: initPagination,
    });
    const handleFilterChange = useCallback((filter) => {
        dispatch({ type: "FILTER_UPDATED", payload: filter });
    }, [dispatch]);
    const handleSortChange = useCallback((sort) => {
        dispatch({ type: "SORT_UPDATED", payload: sort });
    }, [dispatch]);
    const handlePaginationChange = useCallback((pagination) => {
        dispatch({ type: "PAGINATION_UPDATED", payload: pagination });
    }, [dispatch]);
    const handleFilterSortPaginationReset = useCallback(() => {
        dispatch({ type: "RESET" });
    }, [dispatch]);
    return {
        filter: state.filter,
        sort: state.sort,
        pagination: state.pagination,
        handleFilterChange,
        handleSortChange,
        handlePaginationChange,
        handleFilterSortPaginationReset,
    };
}
export default useFilterSortPagination;
//# sourceMappingURL=useFilterSortPagination.js.map